import React, { useState, useEffect } from 'react';
import config from '../../config';

function StockPaymentModel({ showModal, closeModal, onSave, stockPayment, supplierName, }) {
    const [error, setError] = useState(null);
    const [chequeDetails, setChequeDetails] = useState([]);
    const [paymentType, setPaymentType] = useState('cash');
    const [formData, setFormData] = useState({
        name: '',
        chequeAmount: '',
        cashAmount: '',
        total: '',
        due: '',
        payment: '',
    });

    const totalDueAmount = parseFloat(formData.due) || 0;
    const totalPayingAmount = (parseFloat(formData.payment) || 0) +
        (chequeDetails.reduce((sum, d) => sum + parseFloat(d.chequeAmounts || 0), 0));
    const totalChequeAmount = chequeDetails.reduce((sum, d) => sum + parseFloat(d.chequeAmounts || 0), 0);

    useEffect(() => {
        if (stockPayment) {
            setFormData({
                name: supplierName || 'Unknown Supplier',
                chequeAmount: stockPayment.chequeAmount || '0',
                cashAmount: stockPayment.cashAmount || '0',
                total: stockPayment.total || '0',
                due: stockPayment.due || '0',
                payment: '',
            });
        }
    }, [stockPayment, supplierName]);

    useEffect(() => {
        const totalCheque = chequeDetails.reduce((sum, d) => sum + (parseFloat(d.chequeAmounts) || 0), 0);
        const cash = parseFloat(formData.payment) || 0;
        const newDue = (parseFloat(formData.due) || 0) - totalCheque - cash;

        setFormData(prev => ({
            ...prev,
            chequeAmount: totalCheque.toFixed(2),
            cashAmount: cash.toFixed(2),
            due: Math.max(newDue, 0).toFixed(2)
        }));
    }, [chequeDetails, formData.payment]);

    const handlePaymentTypeChange = (type) => {
        setPaymentType(type);
        if (type === 'cash') setChequeDetails([]);
    };

    const handleAddChequeField = () => {
        setChequeDetails([...chequeDetails, { chequeNumber: '', chequeAmounts: '', chequeDate: '' }]);
    };

    const handleDynamicFieldChange = (index, field, value) => {
        const updated = [...chequeDetails];
        updated[index][field] = value;
        setChequeDetails(updated);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log("stockPayment object:", stockPayment);

        try {
            const { payment, due } = formData;
            const getSriLankanTime = () => {
                const now = new Date();
                const sriLankanOffset = 5.5 * 60 * 60 * 1000;
                const sriLankanTime = new Date(now.getTime() + sriLankanOffset);
                return sriLankanTime.toISOString().slice(0, 16);
            };

            if (payment > 0 || chequeDetails.length > 0) {
                const stockPaymentId = stockPayment?.stockPaymentId;
                if (stockPaymentId === undefined || stockPaymentId === null) {
                    throw new Error("stock Payment ID is missing.");
                }

                // Determine if the due is now 0
                const dueAmount = parseFloat(due);
                const paymentStatus = dueAmount <= 0 ? "Paid" : stockPayment?.stockPaymentStatus || "Pending";

                // Step 1: Create Supplier Payment
                const supplierPaymentResponse = await fetch(`${config.BASE_URL}/stockPayment/${stockPaymentId}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        cashAmount: formData.cashAmount,
                        chequeAmount: formData.chequeAmount,
                        stockPayDate: getSriLankanTime(),
                        due: formData.due,
                        stockPaymentStatus: paymentStatus,
                    }),
                });

                if (!supplierPaymentResponse.ok) {
                    const error = await supplierPaymentResponse.json();
                    throw new Error(error.message || 'Failed to create supplier payment.');
                }

                const supplierPaymentData = await supplierPaymentResponse.json();
                console.log('Supplier Payment Created:', supplierPaymentData);
            } else {
                console.log("Skipping Supplier Payment Creation as payment is 0 or condition not met");
            }

            // Step 2: Add Cheque Details (if applicable)
            if (chequeDetails.length > 0) {
                const supplierId = stockPayment.supplierId;

                if (!supplierId) {
                    throw new Error("Supplier ID is missing.");
                }

                const chequeResponse = await fetch(`${config.BASE_URL}/cheque`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(
                        chequeDetails.map((cheque) => ({
                            chequeNumber: cheque.chequeNumber,
                            chequeAmount: cheque.chequeAmounts,
                            issuedDate: getSriLankanTime(),
                            chequeDate: cheque.chequeDate,
                            supplierId,
                            stockPaymentId: stockPayment?.stockPaymentId,
                        }))
                    ),
                });

                if (!chequeResponse.ok) {
                    const error = await chequeResponse.json();
                    console.error('Error details:', error);
                    throw new Error(error.error || 'Failed to add cheque details.');
                }

                const chequeData = await chequeResponse.json();
                console.log('Cheques Added:', chequeData);
            }

            // step 3: Create supplier payment with correct payment type
            const supplierPaymentResponse = await fetch(`${config.BASE_URL}/supplierPayment`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    payDate: getSriLankanTime(),
                    payAmount: totalPayingAmount,
                    paymentType: paymentType,
                    stockPaymentId: stockPayment?.stockPaymentId,
                })
            });

            if (!supplierPaymentResponse.ok) {
                const error = await supplierPaymentResponse.json();
                console.error('Error details:', error);
                throw new Error(error.error || 'Failed to add supplier payment.');
            }

            const supplierPaymentData = await supplierPaymentResponse.json();
            console.log('Supplier Payment Added:', supplierPaymentData);

            onSave({ ...formData, chequeDetails });
            closeModal();
        } catch (err) {
            console.error('Error submitting form:', err);
            setError(err.message);
        }
    };

    if (!showModal) return null;

    return (

        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000, backdropFilter: "blur(2px)" }}>

            <div style={{ background: "#ffffff", borderRadius: "12px", boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)", width: "90%", maxWidth: "600px", maxHeight: "90vh", overflowY: "auto" }}>

                <div style={{ padding: "1.5rem", borderBottom: "1px solid #e9ecef", backgroundColor: "#f8f9fa", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h5 style={{ fontSize: "1.4rem", fontWeight: "600", color: "#2c3e50", margin: 0 }}>
                        <i className="bi bi-wallet2" style={{ marginRight: "0.5rem" }}></i>
                        Payment for {supplierName}
                    </h5>

                    <button
                        type="button"
                        onClick={closeModal}
                        style={{ background: "none", border: "none", fontSize: "1.2rem", cursor: "pointer" }}>
                        &times;
                    </button>
                </div>

                <div style={{ padding: "1.5rem" }}>

                    <div style={{ backgroundColor: "#f8f9fa", borderRadius: "8px", padding: "1rem", border: "1px solid #e9ecef", marginBottom: "1.5rem" }}>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div>
                                <span style={{ color: "#6c757d", fontSize: "0.9rem" }}>Total Balance:</span>
                                <h3 style={{ color: "#e74c3c", margin: "0.5rem 0 0 0" }}>
                                    LKR {totalDueAmount.toFixed(2)}
                                </h3>
                            </div>
                            <div>
                                <span style={{ color: "#6c757d", fontSize: "0.9rem" }}>Total Paying:</span>
                                <h3 style={{ color: "#27ae60", margin: "0.5rem 0 0 0" }}>
                                    LKR {totalPayingAmount.toFixed(2)}
                                </h3>
                            </div>
                        </div>
                    </div>

                    <div style={{ marginBottom: "1.5rem" }}>
                        <label style={{ fontWeight: "600", color: "#6c757d", marginBottom: "0.5rem", display: "block" }}>
                            SELECT PAYMENT METHOD
                        </label>
                        <div style={{ display: "flex", gap: "0.5rem" }}>
                            <button
                                style={{
                                    flex: 1,
                                    padding: "0.8rem",
                                    border: `1px solid ${paymentType === 'cash' ? '#3498db' : '#dee2e6'}`,
                                    borderRadius: "8px",
                                    background: paymentType === 'cash' ? "#3498db" : "#fff",
                                    color: paymentType === 'cash' ? "white" : "#6c757d",
                                    cursor: "pointer"
                                }}
                                onClick={() => handlePaymentTypeChange('cash')}
                            >
                                <i className="bi bi-cash"></i> Cash
                            </button>
                            <button
                                style={{
                                    flex: 1,
                                    padding: "0.8rem",
                                    border: `1px solid ${paymentType === 'cheque' ? '#3498db' : '#dee2e6'}`,
                                    borderRadius: "8px",
                                    background: paymentType === 'cheque' ? "#3498db" : "#fff",
                                    color: paymentType === 'cheque' ? "white" : "#6c757d",
                                    cursor: "pointer"
                                }}
                                onClick={() => handlePaymentTypeChange('cheque')}
                            >
                                <i className="bi bi-wallet2"></i> Cheque
                            </button>
                        </div>
                    </div>

                    {paymentType === 'cheque' && (
                        <div style={{ marginBottom: "1.5rem" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
                                <div>
                                    <span style={{ color: "#6c757d" }}>Total Cheque Amount:</span>
                                    <h4 style={{ color: "#2980b9", margin: 0 }}>LKR {totalChequeAmount.toFixed(2)}</h4>
                                </div>
                                <button
                                    style={{ background: "#3498db", color: "white", border: "none", borderRadius: "6px", padding: "0.5rem 1rem", cursor: "pointer" }}
                                    onClick={handleAddChequeField}
                                >
                                    <i className="bi bi-plus-circle"></i> Add New Cheque
                                </button>
                            </div>

                            {chequeDetails.map((detail, index) => (
                                <div key={index} style={{ backgroundColor: "#f8f9fa", borderRadius: "8px", padding: "1rem", border: "1px solid #e9ecef", marginBottom: "1rem" }}>

                                    <div style={{ display: "flex", gap: "1rem" }}>
                                        <div style={{ flex: 1 }}>
                                            <label style={{ color: "#6c757d" }}>Cheque Number</label>
                                            <input
                                                type="text"
                                                style={{ width: "100%", padding: "0.5rem", borderRadius: "6px" }}
                                                value={detail.chequeNumber}
                                                onChange={(e) => handleDynamicFieldChange(index, 'chequeNumber', e.target.value)}
                                            />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <label style={{ color: "#6c757d" }}>Amount</label>
                                            <input
                                                type="number"
                                                style={{ width: "100%", padding: "0.5rem", borderRadius: "6px" }}
                                                value={detail.chequeAmounts}
                                                onChange={(e) => handleDynamicFieldChange(index, 'chequeAmounts', e.target.value)}
                                            />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <label style={{ color: "#6c757d" }}>Date</label>
                                            <input
                                                type="date"
                                                style={{ width: "100%", padding: "0.5rem", borderRadius: "6px" }}
                                                value={detail.chequeDate}
                                                onChange={(e) => handleDynamicFieldChange(index, 'chequeDate', e.target.value)}
                                            />
                                        </div>
                                    </div>

                                </div>
                            ))}
                        </div>
                    )}

                    {paymentType === 'cash' && (
                        <div style={{ marginBottom: "1.5rem" }}>

                            <label style={{ fontWeight: "600", color: "#6c757d", marginBottom: "0.5rem", display: "block" }}>
                                CASH PAYMENT AMOUNT
                            </label>
                            <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                <span style={{ background: "#e9ecef", padding: "0.5rem", borderRadius: "6px" }}>
                                    LKR
                                </span>
                                <input
                                    type="number"
                                    style={{ flex: 1, padding: "0.8rem", borderRadius: "8px", border: "1px solid #dee2e6" }}
                                    placeholder="Enter amount"
                                    value={formData.payment}
                                    onChange={(e) => setFormData(prev => ({ ...prev, payment: e.target.value }))}
                                />
                            </div>
                        </div>
                    )}

                </div>

                <div style={{ padding: "1rem 1.5rem", borderTop: "1px solid #e9ecef", backgroundColor: "#f8f9fa", display: "flex", justifyContent: "flex-end", gap: "0.5rem" }}>

                    <button
                        style={{ background: "#6c757d", color: "white", border: "none", borderRadius: "6px", padding: "0.5rem 1rem", cursor: "pointer" }}
                        onClick={closeModal}
                    >
                        Cancel
                    </button>

                    <button
                        style={{ background: "#28a745", color: "white", border: "none", borderRadius: "6px", padding: "0.5rem 1rem", cursor: "pointer" }}
                        onClick={handleSubmit}
                    >
                        Confirm Payment
                    </button>

                </div>

            </div>
        </div>
    );
}

export default StockPaymentModel;